const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '大项目审核',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '招标人信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.getBaseInfo()
        },
        getBaseInfo() {
            const guid = this.form.businessKey.split(':')[1]
            this.$request.post(`/transformToAfter/gt-jy-jianguan/api/daXiangMuXinXi/getXiangMuDetail.do`, {
                guid: guid,
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '业主单位': res.data.qiYe_Name,
                    '委托单位': res.data.weituoDepartment,
                    '项目地址': res.data.xiangMuDiZhi,
                    '项目规模': res.data.guiMo,
                    '批准文号': res.data.piZhunWenHao,
                    '是否立项': res.data.laiYuan,
                    '是否进场项目': res.data.isJinChang ? '进场' : '非进场',
                    '项目审批单位': res.data.shenPiDanWei,
                    '立项批文名称': res.data.liXiangPiWenName,
                    '投资来源': res.data.touZiLaiYuan,
                }
                this.config[3].options.data = {
                    '业主单位': res.data.yeZhuDanWei.qiYe_Name,
                    '委托单位': res.data.weituoDepartment,
                    '委托日期': this.$util.timeFormatter(res.data.submitTime),
                    '业主单位地址': res.data.yeZhuDanWei.jinYing_DiZhi,
                    '业主单位组织机构代码': res.yeZhuDanWei.data.piZhunWenHao,
                    '联系电话': res.data.yeZhuDanWei.lianXiRen_Mobile,
                    '单位联系人': res.data.yeZhuDanWei.lianXiRen_Name,
                    '手机': res.data.yeZhuDanWei.lianXiRen_Phone,
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
